export default [
  ["Nombre", null],
  ["Tipo", null],
  ["Coordinador", null],
  ["Fecha de creación", null],
  ["Institución", null],
  ["", null],
];
